import React from "react";
import hombre from "../../assets/images/man/Hombre_compressed.png";
import dama from "../../assets/images/woman/dama_compressed.png";
import "./style.css";

const DressCode = () => {
  return (
    <section id="dressCode" className="dress-section">
      <div className="container">

        <div className="dress-header" data-aos="fade-up">
          <h2 className="dress-title">Dress Code</h2>
          <div className="dress-rule"></div>
          <p className="dress-subtitle">Etiqueta Rigurosa</p>
        </div>

        <div className="dress-cards" data-aos="fade-up" data-aos-delay="100">
          <div className="dress-card">
            <img
              className="dress-icon sink-on-hover"
              src={hombre}
              alt="Hombres"
            />
            <h4 className="dress-card-title">Hombres</h4>
            <p className="dress-card-desc">Smoking o traje completo<br />con zapato formal.</p>
          </div>

          <div className="dress-separator"></div>

          <div className="dress-card">
            <img
              className="dress-icon dress-icon--dama sink-on-hover"
              src={dama}
              alt="Mujeres"
            />
            <h4 className="dress-card-title">Mujeres</h4>
            <p className="dress-card-desc">Vestido largo.</p>
          </div>
        </div>

        <div className="dress-note" data-aos="fade-up" data-aos-delay="200">
          <div className="dress-rule dress-rule--short"></div>
          <p className="dress-no-children">Es un evento solo para adultos &mdash; No niños</p>
        </div>

      </div>
    </section>
  );
};

export default DressCode;
